<!-- Form -->
@if (form) {
  <medsurf-design-form-control-form
    [formGroup]="form"
    (onSubmit)="onSubmit()">
    @if (trainingSharedFacade.choicesByIds$(question.choices) | async | sortBy_shared:'asc':'order'; as choices) {
      <div
        class="flex flex-column row-gap-2">
        <!-- Label -->
        <medsurf-editor [formField]="false"
          [control]="form.controls.content"
          label="global.question_text"
          placeholder="global.question_text"
        (valueChange)="onSubmit()"></medsurf-editor>
        <!-- Placeholder -->
        <medsurf-design-form-control-input-text [control]="form.controls.placeholder"
          [label]="'global.placeholder'"
          [inputClass]="FlatModels.TextDesignModels.TextDesignClass.DEFAULT"
          [placeholder]="'global.placeholder'"
        (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
        <!-- Choices -->
        <div class="flex flex-grow-1 flex-shrink-1 flex-column row-gap-1 mb-2 drag-node">
          <span class="white-space-nowrap overflow-hidden text-overflow-ellipsis mb-2">
            {{ 'global.choices' | translate }}:
          </span>
          <div class="flex flex-column row-gap-2">
            <div class="flex flex-1 flex-column row-gap-2"
              [dragula]="getDragulaKey('choices')"
              [dragulaModel]="choices"
              (dragulaModelChange)="onChoiceMoved(question, $event)">
              @for (choice of choices; track trackByChoice(j, choice); let j = $index) {
                <div class="flex flex-grow-1 flex-shrink-1 flex-column row-gap-1 drag-node">
                  <div class="flex flex-grow-1 flex-row column-gap-2 align-items-center h-row border-round hover:surface-hover cursor-pointer">
                    <div class="flex w-2rem">
                      <button medsurf-design-input-button [id]="'choice_handle_' + choice.id"
                        [title]="'global.choice_handle' | translate"
                        [class]="'handle cursor-move'"
                        [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.HANDLE_OUTLINED_WHITE"
                      [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MOVE"></button>
                    </div>
                    <medsurf-quiz-mapping-question-choice [class]="'w-full'"
                      [question]="question"
                      [choice]="choice"
                    [index]="j"></medsurf-quiz-mapping-question-choice>
                  </div>
                </div>
              }
            </div>
            <button medsurf-design-input-button [id]="'mapping_choice_add'"
              [title]="'global.choice_add'| translate"
              class="align-self-start"
              [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_OUTLINED"
              [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ADD"
            (click)="addChoice(question)"></button>
          </div>
        </div>
        <!-- Solutions -->
        <div class="flex flex-grow-1 flex-shrink-1 flex-column row-gap-1 mb-2 drag-node">
          <span class="white-space-nowrap overflow-hidden text-overflow-ellipsis mb-2">
            {{ 'global.solutions' | translate }}:
          </span>
          <div class="flex flex-column row-gap-2">
            <div class="flex flex-1 flex-column row-gap-2 w-full"
              [dragula]="getDragulaKey('solutions')"
              [dragulaModel]="question.solutions"
              (dragulaModelChange)="onSolutionMoved($event)">
              @for (solution of question.solutions; track solution; let j = $index) {
                <div class="flex flex-grow-1 flex-shrink-1 flex-column row-gap-1 drag-node">
                  <div class="flex flex-grow-1 flex-row column-gap-2 align-items-center h-row border-round hover:surface-hover cursor-pointer">
                    <div class="flex w-2rem">
                      <button medsurf-design-input-button [id]="'solution_handle_' + index"
                        [title]="'global.solution_handle' | translate"
                        [class]="'handle cursor-move'"
                        [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.HANDLE_OUTLINED_WHITE"
                      [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MOVE"></button>
                    </div>
                    <medsurf-quiz-mapping-question-solution [class]="'w-full'"
                      [question]="question"
                      [choices]="choices"
                      [index]="j"
                    (solutionChange)="onSolutionChange($event)"></medsurf-quiz-mapping-question-solution>
                  </div>
                </div>
              }
            </div>
            <button medsurf-design-input-button [id]="'mapping_solution_add'"
              [title]="'global.solution_add' | translate"
              class="align-self-start"
              [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_OUTLINED"
              [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ADD"
            (click)="addSolution(question)"></button>
          </div>
        </div>
        <!-- Explanation -->
        <medsurf-editor [formField]="false"
          [control]="form.controls.explanation"
          label="global.explanation_text"
          placeholder="global.explanation_text_description"
        (valueChange)="onSubmit()"></medsurf-editor>
      </div>
    }
  </medsurf-design-form-control-form>
}
